export const ClientOneHTML = (clientData: any) => {
    if (!clientData) return "";

    // Function to format dates properly
    const formatDate = (date: any) => {
        if (!date) return "DD/MM/YYYY";
        const d = new Date(date);
        return isNaN(d.getTime()) ? "DD/MM/YYYY" : d.toLocaleDateString("en-GB");
    };

    return `
      <div style="border: 2px solid blue; padding: 20px; font-family: Arial, sans-serif; line-height: 1.6;">
        <div style="text-align: center; margin-bottom: 20px;">
          <img src="/assets/images/fintrack_logo.png" 
               alt="Company Logo" 
               style="max-width: 150px; max-height: 150px; margin: 0 auto;">
        </div>
        
        <h2 style="color: blue; margin-bottom: 15px;">Client 1 - Details</h2>

        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
          <tr><td style="padding: 8px;"><strong>First Name:</strong></td><td>${clientData.client1FirstName || "N/A"}</td></tr>
          <tr><td style="padding: 8px;"><strong>Last Name:</strong></td><td>${clientData.client1LastName || "N/A"}</td></tr>
          <tr><td style="padding: 8px;"><strong>Mobile Number:</strong></td><td>${clientData.client1Mobile || "N/A"}</td></tr>
          <tr><td style="padding: 8px;"><strong>Email:</strong></td><td>${clientData.client1Email || "N/A"}</td></tr>
          <tr><td style="padding: 8px;"><strong>Gender:</strong></td><td>${clientData.client1Gender || "N/A"}</td></tr>
          <tr><td style="padding: 8px;"><strong>Date of Birth:</strong></td><td>${formatDate(clientData.client1DateOfBirth)}</td></tr>
          <tr><td style="padding: 8px;"><strong>Marital Status:</strong></td><td>${clientData.client1MaritalStatus || "N/A"}</td></tr>
          <tr><td style="padding: 8px;"><strong>Resident Status:</strong></td><td>${clientData.client1ResidentStatus || "N/A"}</td></tr>
          <tr><td style="padding: 8px;"><strong>Credit Status:</strong></td><td>${clientData.client1CreditStatus || "N/A"}</td></tr>
          <tr><td style="padding: 8px;"><strong>Home Status:</strong></td><td>${clientData.client1HomeStatus || "N/A"}</td></tr>
        </table>

        <h2 style="color: blue; margin-top: 20px; margin-bottom: 10px;">Address History (3 Years)</h2>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
          <tr style="background: #f0f0f0;">
            <th style="padding: 8px; border: 1px solid blue;">Home Address</th>
            <th style="padding: 8px; border: 1px solid blue;">Start Date</th>
          </tr>
          ${[
            { address: clientData.client1Address1, startDate: clientData.client1Address1StartDate },
            { address: clientData.client1Address2, startDate: clientData.client1Address2StartDate },
            { address: clientData.client1Address3, startDate: clientData.client1Address3StartDate },
        ]
            .map(
                (addr) => `
            <tr>
              <td style="padding: 8px; border: 1px solid blue;">${addr.address || "N/A"}</td>
              <td style="padding: 8px; border: 1px solid blue;">${formatDate(addr.startDate)}</td>
            </tr>`
            )
            .join("")}
        </table>

        <h2 style="color: blue; margin-top: 20px;  margin-bottom: 10px;">Employment</h2>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
          <tr style="background: #f0f0f0;">
            <th style="padding: 8px; border: 1px solid blue;">Income Type</th>
            <th style="padding: 8px; border: 1px solid blue;">Income ($)</th>
            <th style="padding: 8px; border: 1px solid blue;">Frequency</th>
          </tr>
          ${[
            { type: "Salary / Wages", amount: clientData.client1IncomeSalaryWages, frequency: clientData.client1IncomeSalaryFrequency },
            { type: "Family Allowance", amount: clientData.client1FamilyAllowance, frequency: clientData.client1FamilyAllowanceFrequency },
            { type: "Dividend Income", amount: clientData.client1DividendIncome, frequency: clientData.client1DividendIncomeFrequency },
            { type: "Company Net Profit", amount: clientData.client1CompanyNetProfit, frequency: clientData.client1CompanyNetProfitFrequency },
        ]
            .map(
                (income) => `
            <tr>
              <td style="padding: 8px; border: 1px solid blue;">${income.type}</td>
              <td style="padding: 8px; border: 1px solid blue;">$${income.amount || "0"}</td>
              <td style="padding: 8px; border: 1px solid blue;">${income.frequency || "N/A"}</td>
            </tr>`
            )
            .join("")}
        </table>

        <h2 style="color: blue; margin-top: 20px; margin-bottom: 10px;">Employment History (3 Years)</h2>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
          <tr style="background: #f0f0f0;">
            <th style="padding: 8px; border: 1px solid blue;">Employer Name</th>
            <th style="padding: 8px; border: 1px solid blue;">Role</th>
            <th style="padding: 8px; border: 1px solid blue;">Start Date</th>
          </tr>
          ${[
            { employer: clientData.client1CompanyName1, role: clientData.client1Role1, startDate: clientData.client1StartDate1 },
            { employer: clientData.client1CompanyName2, role: clientData.client1Role2, startDate: clientData.client1StartDate2 },
            { employer: clientData.client1CompanyName3, role: clientData.client1Role3, startDate: clientData.client1StartDate3 },
        ]
            .map(
                (job) => `
            <tr>
              <td style="padding: 8px; border: 1px solid blue;">${job.employer || "N/A"}</td>
              <td style="padding: 8px; border: 1px solid blue;">${job.role || "N/A"}</td>
              <td style="padding: 8px; border: 1px solid blue;">${formatDate(job.startDate)}</td>
            </tr>`
            )
            .join("")}
        </table>
      </div>
    `;
};


export const ClientTwoHTML = (clientData: any) => {
    // Function to format dates properly
    const formatDate = (date: any) => {
        if (!date) return "DD/MM/YYYY";
        const d = new Date(date);
        return isNaN(d.getTime()) ? "DD/MM/YYYY" : d.toLocaleDateString("en-GB");
    };

    return `
      <div style="border: 2px solid blue; padding: 20px; font-family: Arial, sans-serif; line-height: 1.6;">
        <h2 style="color: blue; margin-bottom: 15px;">Client 2 - Details</h2>

        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
          <tr><td style="padding: 8px;"><strong>First Name:</strong></td><td>${clientData?.client2FirstName || ""}</td></tr>
          <tr><td style="padding: 8px;"><strong>Last Name:</strong></td><td>${clientData?.client2LastName || ""}</td></tr>
          <tr><td style="padding: 8px;"><strong>Mobile Number:</strong></td><td>${clientData?.client2Mobile || ""}</td></tr>
          <tr><td style="padding: 8px;"><strong>Email:</strong></td><td>${clientData?.client2Email || ""}</td></tr>
          <tr><td style="padding: 8px;"><strong>Gender:</strong></td><td>${clientData?.client2Gender || ""}</td></tr>
          <tr><td style="padding: 8px;"><strong>Date of Birth:</strong></td><td>${formatDate(clientData?.client2DateOfBirth)}</td></tr>
          <tr><td style="padding: 8px;"><strong>Marital Status:</strong></td><td>${clientData?.client2MaritalStatus || ""}</td></tr>
          <tr><td style="padding: 8px;"><strong>Resident Status:</strong></td><td>${clientData?.client2ResidentStatus || ""}</td></tr>
          <tr><td style="padding: 8px;"><strong>Credit Status:</strong></td><td>${clientData?.client2CreditStatus || ""}</td></tr>
          <tr><td style="padding: 8px;"><strong>Home Status:</strong></td><td>${clientData?.client2HomeStatus || ""}</td></tr>
        </table>

        <h2 style="color: blue; margin-top: 20px;">Address History (3 Years)</h2>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
          <tr style="background: #f0f0f0;">
            <th style="padding: 8px; border: 1px solid blue;">Home Address</th>
            <th style="padding: 8px; border: 1px solid blue;">Start Date</th>
          </tr>
          ${[
            { address: clientData?.client2Address1, startDate: clientData?.client2Address1StartDate },
            { address: clientData?.client2Address2, startDate: clientData?.client2Address2StartDate },
            { address: clientData?.client2Address3, startDate: clientData?.client2Address3StartDate },
        ]
            .map(
                (addr) => `
            <tr>
              <td style="padding: 8px; border: 1px solid blue;">${addr.address || ""}</td>
              <td style="padding: 8px; border: 1px solid blue;">${formatDate(addr.startDate)}</td>
            </tr>`
            )
            .join("")}
        </table>

        <h2 style="color: blue; margin-top: 20px;">Employment</h2>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
          <tr style="background: #f0f0f0;">
            <th style="padding: 8px; border: 1px solid blue;">Income Type</th>
            <th style="padding: 8px; border: 1px solid blue;">Income ($)</th>
            <th style="padding: 8px; border: 1px solid blue;">Frequency</th>
          </tr>
          ${[
            { type: "Salary / Wages", amount: clientData?.client2IncomeSalaryWages, frequency: clientData?.client2IncomeSalaryFrequency },
            { type: "Family Allowance", amount: clientData?.client2FamilyAllowance, frequency: clientData?.client2FamilyAllowanceFrequency },
            { type: "Dividend Income", amount: clientData?.client2DividendIncome, frequency: clientData?.client2DividendIncomeFrequency },
            { type: "Company Net Profit", amount: clientData?.client2CompanyNetProfit, frequency: clientData?.client2CompanyNetProfitFrequency },
        ]
            .map(
                (income) => `
            <tr>
              <td style="padding: 8px; border: 1px solid blue;">${income.type}</td>
              <td style="padding: 8px; border: 1px solid blue;">$${income.amount || "0"}</td>
              <td style="padding: 8px; border: 1px solid blue;">${income.frequency || ""}</td>
            </tr>`
            )
            .join("")}
        </table>

        <h2 style="color: blue; margin-top: 20px;">Employment History (3 Years)</h2>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
          <tr style="background: #f0f0f0;">
            <th style="padding: 8px; border: 1px solid blue;">Employer Name</th>
            <th style="padding: 8px; border: 1px solid blue;">Role</th>
            <th style="padding: 8px; border: 1px solid blue;">Start Date</th>
          </tr>
          ${[
            { employer: clientData?.client2CompanyName1, role: clientData?.client2Role1, startDate: clientData?.client2StartDate1 },
            { employer: clientData?.client2CompanyName2, role: clientData?.client2Role2, startDate: clientData?.client2StartDate2 },
            { employer: clientData?.client2CompanyName3, role: clientData?.client2Role3, startDate: clientData?.client2StartDate3 },
        ]
            .map(
                (job) => `
            <tr>
              <td style="padding: 8px; border: 1px solid blue;">${job.employer || ""}</td>
              <td style="padding: 8px; border: 1px solid blue;">${job.role || ""}</td>
              <td style="padding: 8px; border: 1px solid blue;">${formatDate(job.startDate)}</td>
            </tr>`
            )
            .join("")}
        </table>
      </div>
    `;
};


export const DependentsHTML = (dependentsData: any) => {
    const dependents = [
        { name: dependentsData?.dependent1Name, age: dependentsData?.dependent1Age },
        { name: dependentsData?.dependent2Name, age: dependentsData?.dependent2Age },
        { name: dependentsData?.dependent3Name, age: dependentsData?.dependent3Age },
        { name: dependentsData?.dependent4Name, age: dependentsData?.dependent4Age },
    ].filter(dep => dep.name?.trim() && Number(dep.age) > 0); // Modified filter condition

    return `
        <div style="border: 2px solid blue; padding: 20px; font-family: Arial, sans-serif; line-height: 1.6;">
            <h2 style="color: blue; margin-bottom: 15px;">Dependent Information</h2>
            <table style="width: 100%; border-collapse: collapse;">
                <tr style="background: #f0f0f0;">
                    <th style="padding: 8px; border: 1px solid blue;">#</th>
                    <th style="padding: 8px; border: 1px solid blue;">Dependent Name</th>
                    <th style="padding: 8px; border: 1px solid blue;">Age</th>
                </tr>
                ${dependents.length > 0 ? dependents.map((dep, index) => `
                    <tr>
                        <td style="padding: 8px; border: 1px solid blue;">${index + 1}</td>
                        <td style="padding: 8px; border: 1px solid blue;">${dep.name}</td>
                        <td style="padding: 8px; border: 1px solid blue;">${dep.age && Number(dep.age) > 0 ? dep.age : "N/A"}</td>
                    </tr>
                `).join('') : `
                    <tr>
                        <td style="padding: 8px; border: 1px solid blue;" colspan="3">No dependents available</td>
                    </tr>
                `}
            </table>
        </div>
    `;
};

export const AssetsHTML = (assetsData: any[]) => {
    // Function to format date
    const formatDate = (date: any) => {
        if (!date) return "DD/MM/YYYY";
        const d = new Date(date);
        return isNaN(d.getTime()) ? "DD/MM/YYYY" : d.toLocaleDateString("en-GB");
    };

    return `
        <div style="border: 2px solid blue; padding: 20px; font-family: Arial, sans-serif; line-height: 1.6;">
            <h2 style="color: blue; margin-bottom: 15px;">Assets - Property</h2>
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px; border: 2px solid blue;">
                <thead>
                    <tr style="background: #f0f0f0; border-bottom: 2px solid blue;">
                        <th style="padding: 8px; border: 1px solid blue;">#</th>
                        <th style="padding: 8px; border: 1px solid blue;">Home Address</th>
                        <th style="padding: 8px; border: 1px solid blue;">Estimated Value ($)</th>
                        <th style="padding: 8px; border: 1px solid blue;">Date Purchased</th>
                        <th style="padding: 8px; border: 1px solid blue;">Property Type</th>
                        <th style="padding: 8px; border: 1px solid blue;">Rental Income ($)</th>
                        <th style="padding: 8px; border: 1px solid blue;">Frequency</th>
                        <th style="padding: 8px; border: 1px solid blue;">Detailed Type</th>
                        <th style="padding: 8px; border: 1px solid blue;">Borrow Type</th>
                        <th style="padding: 8px; border: 1px solid blue;">Current Mortgage ($)</th>
                        <th style="padding: 8px; border: 1px solid blue;">Lender's Name</th>
                        <th style="padding: 8px; border: 1px solid blue;">Repay Type</th>
                        <th style="padding: 8px; border: 1px solid blue;">Repayment ($)</th>
                        <th style="padding: 8px; border: 1px solid blue;">Loan Frequency</th>
                        <th style="padding: 8px; border: 1px solid blue;">Interest Rate (%)</th>
                        <th style="padding: 8px; border: 1px solid blue;">Interest Type</th>
                    </tr>
                </thead>
                <tbody>
                    ${assetsData.length > 0 ? assetsData.map((asset, index) => `
                        <tr>
                            <td style="padding: 8px; border: 1px solid blue;">${index + 1}</td>
                            <td style="padding: 8px; border: 1px solid blue;">${asset.homeAddress || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">$${asset.estimatedValue || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">${formatDate(asset.datePurchased)}</td>
                            <td style="padding: 8px; border: 1px solid blue;">${asset.propertyType || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">$${asset.rentalIncome || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">${asset.frequency || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">${asset.detailedType || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">${asset.borrowType || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">$${asset.currentMortgage || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">${asset.lendersName || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">${asset.repayType || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">$${asset.loanDetailsRepayment || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">${asset.loanFrequency || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">${asset.interestRate || "N/A"}%</td>
                            <td style="padding: 8px; border: 1px solid blue;">${asset.interestType || "N/A"}</td>
                        </tr>
                    `).join('') : `
                        <tr>
                            <td style="padding: 8px; border: 1px solid blue;" colspan="16">No assets available</td>
                        </tr>
                    `}
                </tbody>
            </table>
        </div>
    `;
};


export const AssetsNonPropertyHTML = (assetsData: any) => {
    return `
      <div style="border: 2px solid blue; padding: 20px; font-family: Arial, sans-serif; line-height: 1.6;">
        <h2 style="color: blue; margin-bottom: 15px;">Assets - Non Property Details</h2>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
            <tr><td style="padding: 8px;"><strong>Cash in Bank:</strong></td><td>$ ${assetsData?.nonPropertyCashinBank || "0"}</td></tr>
            <tr><td style="padding: 8px;"><strong>Contents:</strong></td><td>$ ${assetsData?.nonPropertyContents || "0"}</td></tr>
            <tr><td style="padding: 8px;"><strong>Business Value:</strong></td><td>$ ${assetsData?.nonPropertyBusinessValue || "0"}</td></tr>
            <tr><td style="padding: 8px;"><strong>Crypto Currency:</strong></td><td>$ ${assetsData?.nonPropertyCryptoCurrency || "0"}</td></tr>
            <tr><td style="padding: 8px;"><strong>Super Client 1:</strong></td><td>$ ${assetsData?.nonPropertySuperClient1 || "0"}</td></tr>
            <tr><td style="padding: 8px;"><strong>Super Client 2:</strong></td><td>$ ${assetsData?.nonPropertySuperClient2 || "0"}</td></tr>
            <tr><td style="padding: 8px;"><strong>SMSF:</strong></td><td>$ ${assetsData?.nonPropertySMSF || "0"}</td></tr>
        </table>
      </div>
    `;
};

export const AssetsNonPropertyHTML2 = (assetsData: any) => {
    return `
      <div style="border: 2px solid blue; padding: 20px; font-family: Arial, sans-serif; line-height: 1.6;">
        <h2 style="color: blue; margin-bottom: 15px;">Assets - Non Property Details</h2>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
            <tr><td style="padding: 8px;"><strong>Cash & Savings:</strong></td><td>$ ${assetsData?.otherAssetsCashAndSavings || "0"}</td></tr>
            <tr><td style="padding: 8px;"><strong>Super Client 1:</strong></td><td>$ ${assetsData?.superApplicant1 || "0"}</td></tr>
            <tr><td style="padding: 8px;"><strong>Super Client 2:</strong></td><td>$ ${assetsData?.superApplicant2 || "0"}</td></tr>
            <tr><td style="padding: 8px;"><strong>SMSF:</strong></td><td>$ ${assetsData?.smsf || "0"}</td></tr>
        </table>
      </div>
    `;
};


export const VehicleAssetsHTML = (vehiclesData: any[]) => {
    return `
        <div style="border: 2px solid blue; padding: 20px; font-family: Arial, sans-serif; line-height: 1.6;">
            <h2 style="color: blue; margin-bottom: 15px;">Vehicle Assets Details</h2>
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px; border: 2px solid blue;">
                <thead>
                    <tr style="background: #f0f0f0; border-bottom: 2px solid blue;">
                        <th style="padding: 8px; border: 1px solid blue;">#</th>
                        <th style="padding: 8px; border: 1px solid blue;">Make</th>
                        <th style="padding: 8px; border: 1px solid blue;">Year</th>
                        <th style="padding: 8px; border: 1px solid blue;">Estimated Value ($)</th>
                        <th style="padding: 8px; border: 1px solid blue;">Current Loan ($)</th>
                        <th style="padding: 8px; border: 1px solid blue;">Lender's Name</th>
                        <th style="padding: 8px; border: 1px solid blue;">Repayment ($)</th>
                        <th style="padding: 8px; border: 1px solid blue;">Frequency</th>
                        <th style="padding: 8px; border: 1px solid blue;">Interest Rate (%)</th>
                    </tr>
                </thead>
                <tbody>
                    ${vehiclesData.length > 0 ? vehiclesData.map((vehicle, index) => `
                        <tr>
                            <td style="padding: 8px; border: 1px solid blue;">${index + 1}</td>
                            <td style="padding: 8px; border: 1px solid blue;">${vehicle.make || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">${vehicle.year || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">$${vehicle.estimatedValue || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">$${vehicle.currentLoan || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">${vehicle.lendersName || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">$${vehicle.repayment || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">${vehicle.frequency || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">${vehicle.interestRate || "N/A"}%</td>
                        </tr>
                    `).join('') : `
                        <tr>
                            <td style="padding: 8px; border: 1px solid blue;" colspan="9">No vehicle assets available</td>
                        </tr>
                    `}
                </tbody>
            </table>
        </div>
    `;
};

export const LiabilitiesHTML = (liabilitiesData: any[]) => {
    return `
        <div style="border: 2px solid blue; padding: 20px; font-family: Arial, sans-serif; line-height: 1.6;">
            <h2 style="color: blue; margin-bottom: 15px;">Liabilities</h2>
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px; border: 2px solid blue;">
                <thead>
                    <tr style="background: #f0f0f0; border-bottom: 2px solid blue;">
                        <th style="padding: 8px; border: 1px solid blue;">#</th>
                        <th style="padding: 8px; border: 1px solid blue;">Liability Type</th>
                        <th style="padding: 8px; border: 1px solid blue;">Lender's Name</th>
                        <th style="padding: 8px; border: 1px solid blue;">Current Balance ($)</th>
                        <th style="padding: 8px; border: 1px solid blue;">Current Limit ($)</th>
                        <th style="padding: 8px; border: 1px solid blue;">Interest Rate (%)</th>
                        <th style="padding: 8px; border: 1px solid blue;">Repayment ($)</th>
                        <th style="padding: 8px; border: 1px solid blue;">Frequency</th>
                    </tr>
                </thead>
                <tbody>
                    ${liabilitiesData.length > 0 ? liabilitiesData.map((liability, index) => `
                        <tr>
                            <td style="padding: 8px; border: 1px solid blue;">${index + 1}</td>
                            <td style="padding: 8px; border: 1px solid blue;">${liability.liabilityType || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">${liability.lendersName || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">$${liability.currentBalance || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">$${liability.currentLimit || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">${liability.liabilitiesInterestRate || "N/A"}%</td>
                            <td style="padding: 8px; border: 1px solid blue;">$${liability.repayment || "N/A"}</td>
                            <td style="padding: 8px; border: 1px solid blue;">${liability.frequency || "N/A"}</td>
                        </tr>
                    `).join('') : `
                        <tr>
                            <td style="padding: 8px; border: 1px solid blue;" colspan="8">No liabilities available</td>
                        </tr>
                    `}
                </tbody>
            </table>
        </div>
    `;
};

export const ExpenseDetailsHTML = (expenseData: any) => {
    const expenseCategories = [
        {
            category: "Child Care", subcategories: [
                { name: "Child Care & Baby Sitting", amountKey: "childCare_BabySittingAmount", frequencyKey: "childCare_BabySittingFrequency" },
                { name: "Child Maintenance & Support", amountKey: "childMaintenance_SupportAmount", frequencyKey: "childMaintenance_SupportFrequency" },
            ]
        },
        {
            category: "Education", subcategories: [
                { name: "Public School Costs", amountKey: "publicSchoolCosts_Amount", frequencyKey: "publicSchoolCosts_Frequency" },
                { name: "Private School Costs", amountKey: "privateSchoolCosts_Amount", frequencyKey: "privateSchoolCosts_Frequency" },
                { name: "Higher Education HECS/HELP", amountKey: "higherEducationHECSHELP_Amount", frequencyKey: "higherEducationHECSHELP_Frequency" },
            ]
        },
        {
            category: "Groceries", subcategories: [
                { name: "Food", amountKey: "food_Amount", frequencyKey: "food_Frequency" },
            ]
        },
        {
            category: "House You Live In", subcategories: [
                { name: "Body Corporate", amountKey: "bodyCorporate_Amount", frequencyKey: "bodyCorporate_Frequency" },
                { name: "Council Rates", amountKey: "councilRates_Amount", frequencyKey: "councilRates_Frequency" },
                { name: "Electricity", amountKey: "electricity_Amount", frequencyKey: "electricity_Frequency" },
                { name: "Gas", amountKey: "gas_Amount", frequencyKey: "gas_Frequency" },
                { name: "Repairs & Maintenance", amountKey: "repairsMaintenance_Amount", frequencyKey: "repairsMaintenance_Frequency" },
                { name: "Sewer Rates", amountKey: "sewerRates_Amount", frequencyKey: "sewerRates_Frequency" },
                { name: "Water Usage", amountKey: "waterusage_Amount", frequencyKey: "waterusage_Frequency" },
            ]
        },
        {
            category: "Insurance", subcategories: [
                { name: "Building Insurance", amountKey: "buildingInsurance_Amount", frequencyKey: "buildingInsurance_Frequency" },
                { name: "Contents Insurance", amountKey: "contentsInsurance_Amount", frequencyKey: "contentsInsurance_Frequency" },
                { name: "Health Insurance", amountKey: "healthInsurance_Amount", frequencyKey: "healthInsurance_Frequency" },
                { name: "Income Protection", amountKey: "incomeProtection_Amount", frequencyKey: "incomeProtection_Frequency" },
                { name: "Life Insurance", amountKey: "lifeInsurance_Amount", frequencyKey: "lifeInsurance_Frequency" },
                { name: "Vehicle Insurance", amountKey: "vehicleInsurance_Amount", frequencyKey: "vehicleInsurance_Frequency" },
            ]
        }, {
            category: "Medical Expenses", subcategories: [
                { name: "Dental & Optical", amountKey: "dentalOptical_Amount", frequencyKey: "dentalOptical_Frequency" },
                { name: "Medical & Health", amountKey: "medicalHealth_Amount", frequencyKey: "medicalHealth_Frequency" },
                { name: "Natural Therapists", amountKey: "naturalTherapists_Amount", frequencyKey: "naturalTherapists_Frequency" },
            ]
        },
        {
            category: "Ongoing Rent", subcategories: [
                { name: "Board", amountKey: "board_Amount", frequencyKey: "board_Frequency" },
                { name: "Rent", amountKey: "rent_Amount", frequencyKey: "rent_Frequency" },
            ]
        },
    ];

    let tableContent = "";

    for (const { category, subcategories } of expenseCategories) {
        let rows = subcategories.map(({ name, amountKey, frequencyKey }) => {
            const amount = expenseData[amountKey] ?? "0"; // Default to 0 if missing
            const frequency = expenseData[frequencyKey] ?? "N/A";
            return `
                <tr>
                    <td style="padding: 8px; border: 1px solid blue;">${name}</td>
                    <td style="padding: 8px; border: 1px solid blue;">$${amount}</td>
                    <td style="padding: 8px; border: 1px solid blue;">${frequency}</td>
                </tr>
            `;
        }).join("");

        tableContent += `
            <tr style="background: #dbeafe; font-weight: bold;">
                <td colspan="3" style="padding: 10px; text-align: center; border: 2px solid blue;">${category}</td>
            </tr>
            ${rows}
        `;
    }

    return `
        <div style="border: 2px solid blue; padding: 20px; font-family: Arial, sans-serif; line-height: 1.6;">
            <h2 style="color: blue; margin-bottom: 15px;">Expense Details</h2>
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px; border: 2px solid blue;">
                <thead>
                    <tr style="background: #f0f0f0; border-bottom: 2px solid blue;">
                        <th style="padding: 8px; border: 1px solid blue;">Category Name</th>
                        <th style="padding: 8px; border: 1px solid blue;">Amount ($)</th>
                        <th style="padding: 8px; border: 1px solid blue;">Frequency</th>
                    </tr>
                </thead>
                <tbody>
                    ${tableContent}
                </tbody>
            </table>
        </div>
    `;
};


export const ExpenseDetailsHTML2 = (expenseData: any) => {
    const expenseCategories = [
        {
            category: "Personal Care", subcategories: [
                { name: "Clothing & Footwear", amountKey: "clothingFootwear_Amount", frequencyKey: "clothingFootwear_Frequency" },
                { name: "Cosmetics", amountKey: "cosmetics_Amount", frequencyKey: "cosmetics_Frequency" },
                { name: "Dry Cleaning", amountKey: "dryCleaning_Amount", frequencyKey: "dryCleaning_Frequency" },
                { name: "Personal Care", amountKey: "personalCare_Amount", frequencyKey: "personalCare_Frequency" },
            ]
        },
        {
            category: "Recreational & Entertainment", subcategories: [
                { name: "Alcohol & Tobacco", amountKey: "alcoholTabacco_Amount", frequencyKey: "alcoholTabacco_Frequency" },
                { name: "Cinema & Concerts", amountKey: "cinemaConcerts_Amount", frequencyKey: "cinemaConcerts_Frequency" },
                { name: "Dining Out", amountKey: "diningOut_Amount", frequencyKey: "diningOut_Frequency" },
                { name: "Gifts & Miscellaneous", amountKey: "giftsMiscellaneous_Amount", frequencyKey: "giftsMiscellaneous_Frequency" },
                { name: "Gym & Sports", amountKey: "gymSports_Amount", frequencyKey: "gymSports_Frequency" },
                { name: "Pets", amountKey: "pets_Amount", frequencyKey: "pets_Frequency" },
                { name: "Subscriptions", amountKey: "subscriptions_Amount", frequencyKey: "subscriptions_Frequency" },
                { name: "Takeaway", amountKey: "takeaway_Amount", frequencyKey: "takeaway_Frequency" },
                { name: "Travel & Holidays", amountKey: "travelHolidays_Amount", frequencyKey: "travelHolidays_Frequency" },
            ]
        },
        {
            category: "Telephone & Internet", subcategories: [
                { name: "Home & Mobile Phone", amountKey: "homeMobilePhone_Amount", frequencyKey: "homeMobilePhone_Frequency" },
                { name: "Internet", amountKey: "internet_Amount", frequencyKey: "internet_Frequency" },
                { name: "Pay TV & Streaming", amountKey: "payTVStreaming_Amount", frequencyKey: "payTVStreaming_Frequency" },
            ]
        },
        {
            category: "Transport", subcategories: [
                { name: "Petrol", amountKey: "petrol_Amount", frequencyKey: "petrol_Frequency" },
                { name: "Public Transport", amountKey: "publicTransport_Amount", frequencyKey: "publicTransport_Frequency" },
                { name: "Taxi Ride / Uber", amountKey: "taxiRideUber_Amount", frequencyKey: "taxiRideUber_Frequency" },
                { name: "Tolls & Parking", amountKey: "tollsParking_Amount", frequencyKey: "tollsParking_Frequency" },
                { name: "Vehicle Registration", amountKey: "vehicleRegistration_Amount", frequencyKey: "vehicleRegistration_Frequency" },
                { name: "Vehicle Repairs", amountKey: "vehicleRepairs_Amount", frequencyKey: "vehicleRepairs_Frequency" },
            ]
        },
    ];

    let tableContent = "";

    for (const { category, subcategories } of expenseCategories) {
        let rows = subcategories.map(({ name, amountKey, frequencyKey }) => {
            const amount = expenseData[amountKey] ?? "0"; // Default to 0 if missing
            const frequency = expenseData[frequencyKey] ?? "0"; // Changed from "N/A" to "0"
            return `
                <tr>
                    <td style="padding: 8px; border: 1px solid blue;">${name}</td>
                    <td style="padding: 8px; border: 1px solid blue;">$${amount}</td>
                    <td style="padding: 8px; border: 1px solid blue;">${frequency}</td>
                </tr>
            `;
        }).join("");

        tableContent += `
            <tr style="background: #dbeafe; font-weight: bold;">
                <td colspan="3" style="padding: 10px; text-align: center; border: 2px solid blue;">${category}</td>
            </tr>
            ${rows}
        `;
    }

    return `
        <div style="border: 2px solid blue; padding: 20px; font-family: Arial, sans-serif; line-height: 1.6;">
            <h2 style="color: blue; margin-bottom: 15px;">Expense Details</h2>
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px; border: 2px solid blue;">
                <thead>
                    <tr style="background: #f0f0f0; border-bottom: 2px solid blue;">
                        <th style="padding: 8px; border: 1px solid blue;">Category Name</th>
                        <th style="padding: 8px; border: 1px solid blue;">Amount ($)</th>
                        <th style="padding: 8px; border: 1px solid blue;">Frequency</th>
                    </tr>
                </thead>
                <tbody>
                    ${tableContent}
                </tbody>
            </table>
        </div>
    `;
};


export const ExpenseDetailsHTMLtest = (expenseData: any[]) => {
    // Define the type for grouped expenses
    interface GroupedExpenses {
        [key: string]: any[];
    }

    // Group expenses by category
    const groupedExpenses: GroupedExpenses = expenseData.reduce((acc: GroupedExpenses, expense) => {
        const category = expense.categoryName;
        if (!acc[category]) {
            acc[category] = [];
        }
        acc[category].push(expense);
        return acc;
    }, {});

    let tableContent = "";

    // Render each category and its expenses
    Object.entries(groupedExpenses).forEach(([category, expenses]) => {
        let rows = expenses.map(expense => `
            <tr>
                <td style="padding: 8px; border: 1px solid blue;">${expense.categoryName}</td>
                <td style="padding: 8px; border: 1px solid blue;">$${expense.amountValue || "0"}</td>
            </tr>
        `);

        tableContent += `
      
            ${rows}
        `;
    });

    return `
        <div style="border: 2px solid blue; padding: 20px; font-family: Arial, sans-serif; line-height: 1.6;">
            <h2 style="color: blue; margin-bottom: 15px;">Expense Details</h2>
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px; border: 2px solid blue;">
                <thead>
                    <tr style="background: #f0f0f0; border-bottom: 2px solid blue;">
                        <th style="padding: 8px; border: 1px solid blue;">Category Name</th>
                        <th style="padding: 8px; border: 1px solid blue;">Amount ($)</th>
                    </tr>
                </thead>
                <tbody>
                    ${tableContent}
                </tbody>
            </table>
        </div>
    `;
};
